import type { ReactNode } from 'react'

import { Placeholder } from '@/src/elements/placeholder'
import type { TMediumCommunityApi } from '@/src/features/community/api/communityApi.types'
import { IntentionPrayCard } from '@/src/features/intention/ui/components/IntentionPrayCard'
import type { TSourceParam } from '@/src/general/constants/routes'
import { TEST_ID } from '@/src/general/constants/testId'

import { usePublicationRandomIntention } from '../../../hooks/usePublicationRandomIntention'

type TPublicationRewardScreenFooterProps = TSourceParam & {
  community: TMediumCommunityApi
  publicationId: number
  testID: string
}

export const PublicationRandomIntention = ({
  community,
  publicationId,
  testID,
  source,
}: TPublicationRewardScreenFooterProps): ReactNode => {
  const { isLoading, title, intention, onPray } = usePublicationRandomIntention({
    community,
    publicationId,
    source,
  })

  if (isLoading) return <Placeholder testID={TEST_ID.PUBLICATION.REWARD.SCREEN.INTENTIONS.LOADING} />
  if (!intention) return null

  return <IntentionPrayCard title={title} intention={intention} onPray={onPray} testIdPrayButton={testID} />
}
